export const checkRole = (user, role) => user?.role === role;

export const checkPermission = (user, permission) =>
  user?.permissions?.includes(permission) || false;
